import * as React from 'react';
import { authenticationService } from '../../services/authentication';
import { withLoader, EmptyLoader } from '../hocs/LoaderEnhancer';
import { PageRoutes } from '../root/Routes';
import { LogManager } from '../../utils/LogManager';
import { bindObjectMethods } from '../../utils/utilFunctions';
import { errorHandler } from '../../services/errorHandler';

const logManager = new LogManager('SignInRedirect');

class SignInRedirect extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        bindObjectMethods(this, SignInRedirect.prototype);
    }

    componentDidMount() {
        authenticationService.setSocialLoginCallbacks(
            this.onSocialLoginSuccess,
            this.onSocialLoginFailure
        );
        authenticationService.parseCognitoWebResponse();
    }

    render() {
        return <EmptyLoader loading={true} />;
    }

    private onSocialLoginSuccess(): void {
        this.props.history.push(PageRoutes.Dashboard);
    }

    private onSocialLoginFailure(error: any): void {
        logManager.error(error);

        let errorMessage = null;
        try {
            errorMessage = JSON.parse(error);

            switch (errorMessage.error) {
                case 'invalid_grant':
                    authenticationService.retrySocialLogin();
                    break;
                default:
                    errorHandler(error);
            }
        } catch (e) {
            errorHandler(e);
        }
    }
}

export default withLoader(SignInRedirect, 'signInRedirect');



// WEBPACK FOOTER //
// ./src/webportal/components/authentication/SignInRedirect.tsx